import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { environment } from '../utils/Environment'
import { FormData } from 'formdata-node'
import { IncidentResponse, 
    IncidentFormData , 
    UserIncidentFormData, 
    UserIncidentsResponse, 
    SingleIncident, 
    IncidentUpdateFormData} from '../utils/Interface'
import { RootState } from '../store/GlobalStore'

const IncidentAPI = createApi({
    reducerPath: 'IncidentAPI',
    baseQuery: fetchBaseQuery({
        baseUrl: `${environment.api_url as string}incident`,
        prepareHeaders: (headers, { getState }) => {
            //headers.set('Content-Type', 'application/json')
            const token = (getState() as RootState).Auth.jwt
            if (token) {
                headers.set('Authorization', `Bearer ${token}`)
            }
            return headers
        }
    }),
    endpoints: (build) => ({
         // Mutation pour créer un incident
         createIncident: build.mutation<IncidentResponse, IncidentFormData>({
            query: (data: IncidentFormData) => ({
                url: '/create',
                method: 'POST',
                body: data
            })
        }),
        // Query pour récupérer les incidents de l'utilisateur
        getUserIncidents: build.query<UserIncidentsResponse[], UserIncidentFormData>({
            query: (data: UserIncidentFormData) => ({
                url: '/allUserIncidents',
                method: 'POST',
                body: data
            })
        }),
        getIncidentById: build.query<SingleIncident, number>({
            query: (id) => `/findOne/${id}`
        }),
        updateIncident: build.mutation<SingleIncident, IncidentUpdateFormData>({
            query: (data: SingleIncident) => ({
                url: '/update',
                method: 'POST',
                body: data
            })
        }),
    })
})

export default IncidentAPI
export const { useCreateIncidentMutation , useGetUserIncidentsQuery, useGetIncidentByIdQuery, useUpdateIncidentMutation} = IncidentAPI